
import React from 'react';
import "./Login.css"
import PlayStoreIcon from "./Play_Store.png"
import IOSIcon from "./IOS.png"
const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        Copyright © NYGGS Automation Suite 2025
      </div>
      <div className="app-links">
        <div className="qr-code">
         <img src={PlayStoreIcon} alt='' className='qr-code-image'
         onClick={()=> window.open("https://play.google.com/store/apps/details?id=com.nkcerp.unifiednyggs")}
         />
        </div>
        <div className="qr-code" >
        <img src={IOSIcon} alt='' className='qr-code-image'
                 onClick={()=> window.open("https://apps.apple.com/in/app/nyggs-hrms/id6450252599")}
        />
        </div>
      </div>
    </div>
  );
};

export default Footer;